import { FunctionComponent, PropsWithChildren } from 'react';

import { FormControl } from '@mui/material';

import BaseFormInputField from '../../../../../shared/components/base-input-form-field/base-form-input-field';
import { ExceptedAppsReleaseFormProps } from '../types/excepted-apps-release-form-props.type';

export const AndroidPackageInput: FunctionComponent<
  ExceptedAppsReleaseFormProps
> = (props: PropsWithChildren<ExceptedAppsReleaseFormProps>) => {
  const { values, errors, touched, handleChange, handleBlur } = props;

  return (
    <FormControl>
      <BaseFormInputField
        id="android-package"
        label="Android Package"
        name="androidPackage"
        onBlur={handleBlur}
        onChange={handleChange}
        error={!!errors.androidPackage && touched.androidPackage}
        helperText={
          !!errors.androidPackage &&
          touched.androidPackage &&
          errors.androidPackage
        }
        value={values?.androidPackage ?? ''}
        InputLabelProps={{ required: true }}
      />
    </FormControl>
  );
};
